import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { AuthLayout } from '@/components/layout/auth-layout.js';
import { ResetPasswordForm } from '@/features/auth/reset-password-form.js';
import { rootRoute } from './root.js';

/** `/reinitialiser/:token` — `02` §1 : réinitialisation et première connexion après invitation partagent ce lien. */
export const resetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reinitialiser/$token',
  component: ResetPasswordPage,
});

function ResetPasswordPage(): JSX.Element {
  const { token } = resetPasswordRoute.useParams();
  return (
    <AuthLayout title="Réinitialiser le mot de passe" description="Choisissez un nouveau mot de passe (12 caractères minimum).">
      <ResetPasswordForm token={token} />
    </AuthLayout>
  );
}
